import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StatusLayout from "./StatusLayout";
import { useCase } from "../../context/CaseContext";
import { submitPhotoMatch } from "../../lib/everifyStatusApi";

const decisions = [
  { label: "Match", value: "matching" },
  { label: "No Match", value: "not-matching" },
  { label: "No Image", value: "no-image" },
];

const PhotoMatchPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { activeCaseNumber } = useCase();
  const photoUrl = location.state?.photoUrl;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imgError, setImgError] = useState(false);

  const handleDecision = async (value) => {
    if (!activeCaseNumber) {
      toast.error("No case number available.");
      return;
    }

    try {
      setIsSubmitting(true);

      try {
        await submitPhotoMatch(activeCaseNumber, value);
      } catch (e) {
        toast.error("Failed to record your response. Please try again.");
        return;
      }

      toast.success("Response recorded successfully.");

      if (value === "not-matching" || value === "no-image") {
        navigate("/case/scan-upload");
        return;
      }
      navigate("/");
    } finally {
      setIsSubmitting(false);
    }
  };

  const hasPhoto = photoUrl && typeof photoUrl === "string" && !imgError;

  return (
    <StatusLayout
      title="Document Photo Verification Required"
      description="Select the option that best matches the provided document photo."
    >
      <div className="status-section">
        <h3>Provided Photo</h3>
        {hasPhoto ? (
          <img
            src={photoUrl}
            alt="Government-provided document"
            className="status-photo"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="status-no-photo">
            <div className="status-no-photo-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <path d="M21 15l-5-5L5 21" />
              </svg>
            </div>
            <p className="status-no-photo-title">No photo available</p>
            <p className="status-no-photo-sub">
              No document photo was provided for this case. Select <strong>No Image</strong> below to proceed.
            </p>
          </div>
        )}
      </div>

      <div className="status-section">
        <h3>Decision</h3>
        <div className="status-actions">
          {decisions.map((option) => (
            <button
              key={option.value}
              className="status-primary"
              type="button"
              onClick={() => handleDecision(option.value)}
              disabled={isSubmitting}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </StatusLayout>
  );
};

export default PhotoMatchPage;
